import { Select } from "@mui/material";
import React, { useContext } from "react";
import propTypes from "prop-types";
import { ReportParameterTimeTypes } from "../../../../logic/api";
import { SessionContext } from "../../../../utility/useSession";
import { formatCamel } from "../../../../utility/utils";


const ReportParameterTimeAdjustmentField: React.FunctionComponent<{
    label: string,
    value?: ReportParameterTimeTypes;
    onChange: (value: ReportParameterTimeTypes) => void;
}> = (props) => {
    const session = useContext(SessionContext);



    let selectedReportTypeId = -1;
    if (props.value != null) {
        selectedReportTypeId = props.value;
    }

    const reportTypeNames = [];
    for (const a in ReportParameterTimeTypes) {
        if (isNaN(parseInt(a)) == true) {
            reportTypeNames.push(a);
        }
    }


    return <Select
        native
        style={{ width: "100%", maxWidth: 225, borderRadius: 5, padding: 5 }}

        value={selectedReportTypeId}
        onChange={(e) => {
            props.onChange(parseInt(String(e.target.value), 10));
        }}
    >

        {session.current.site != null && reportTypeNames.map((item, i) => {
            return <option key={i} value={i} title={item}>{formatCamel(item)}</option>;
        })}

    </Select>;
}
ReportParameterTimeAdjustmentField.propTypes = {
    label: propTypes.string.isRequired,
    value: propTypes.any,
    onChange: propTypes.func.isRequired
}

export default ReportParameterTimeAdjustmentField;
